import Vue from 'vue'
import VueMeta from 'vue-meta'
import Router from 'vue-router'
import MVMCase from './components/MVMCase.vue'
import MVMInfo from './components/MVMInfo.vue'

Vue.use(Router)
Vue.use(VueMeta)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home'
    },
    {
      path: '/info',
      name: 'info',
      component: MVMInfo
    },
    {
      path: '/case/:slug',
      name: 'case',
      component: MVMCase,
      props: true
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
